import GenericContext from '@contexts/commenting/genericContext'
import TopCommentAPIContext from '@contexts/commenting/topCommentApiContext'
import translate from '@i18n'
import { FunctionComponent, useContext } from 'react'
import Comment from './Comment'
import CommentingItemList from './CommentingItemList'
import Title from './Title'
import { Comment as CommentType } from './types'

const TopComments: FunctionComponent = () => {
  const { topComments } = useContext(TopCommentAPIContext)
  const { articleId, postingEnabled } = useContext(GenericContext)
  const hasTopComments = topComments?.length > 0

  if (!hasTopComments) {
    return null
  }

  return (
    <>
      <Title>{translate('commenting.title.top')}</Title>
      <CommentingItemList
        type="comment"
        moreToShow={false}
        rerenderKey={`top-${articleId}`}>
        {(topComments as CommentType[]).map((comment) => (
          <Comment
            key={`comment-${comment.id}`}
            postingEnabled={postingEnabled}
            comment={comment}
            isTopComment
          />
        ))}
      </CommentingItemList>
    </>
  )
}

export default TopComments
